export default __webpack_public_path__ + "e447daaf89a7ccae3d031dcc44a0311d.png";